import React, { Component } from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { connect } from "react-redux";
import ProfileMain from "../../components/Profile/ProfileMain/ProfileMain";
import { routerLinks } from "../../hoc/Router/routerLinks";
import * as routerTypes from "../../hoc/Router/routerTypes";
import { Redirect, Route, Switch, withRouter } from "react-router";

class Profile extends Component {
  render() {
    let AuthRedirect;
    if (!this.props.isAuthenticated) {
      return <Redirect to="/login" />;
    }

    return (
      <Wrapper>
        <div>
          <Switch>
            <Route
              exact
              path={routerLinks(routerTypes.PROFILE)}
              component={ProfileMain}
            />
          </Switch>
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tokenData: state.auth.token,
    isAuthenticated: state.auth.token !== null,
  };
};

export default withRouter(connect(mapStateToProps)(Profile));